import axios from '@/library/modules/axios'

const POLICY_URL = '/apis/v1/tenant/customer/public/privacy-policy/current'

export function getCurrentPrivacyPolicies() {
  return axios.service({
    url: POLICY_URL,
    method: 'get',
    // 每次进入首页都检查已发布版本，避免浏览器复用旧响应。
    params: { _t: Date.now() }
  }).then(response => response.data)
}

export function getCurrentPrivacyPolicy(docType) {
  return axios.service({
    url: `${POLICY_URL}/${encodeURIComponent(docType)}`,
    method: 'get',
    params: { _t: Date.now() }
  }).then(response => response.data)
}
